import type { QueryClient } from "@tanstack/react-query"

import { isApiError } from "@/lib/api/errors"
import { authQueries } from "@/queries/auth"
import type { Session } from "@/types/auth"

export async function optionalSession(
  queryClient: QueryClient
): Promise<Session | null> {
  try {
    return await queryClient.ensureQueryData(authQueries.session())
  } catch (error) {
    if (isApiError(error) && error.isUnauthenticated) {
      return null
    }

    throw error
  }
}
